/* tslint:disable */
/* eslint-disable */
/**
 * My REST API
 * Some custom description of API.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: jason.tai@octopus-tech.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Language,
    LanguageFromJSON,
    LanguageFromJSONTyped,
    LanguageToJSON,
} from './Language';
import {
    Product,
    ProductFromJSON,
    ProductFromJSONTyped,
    ProductToJSON,
} from './Product';

/**
 * 
 * @export
 * @interface ProductLanguage
 */
export interface ProductLanguage {
    /**
     * 
     * @type {Language}
     * @memberof ProductLanguage
     */
    languageByLanguageId?: Language;
    /**
     * 
     * @type {number}
     * @memberof ProductLanguage
     */
    languageId?: number;
    /**
     * 
     * @type {Product}
     * @memberof ProductLanguage
     */
    productByProductId?: Product;
    /**
     * 
     * @type {number}
     * @memberof ProductLanguage
     */
    productId?: number;
}

export function ProductLanguageFromJSON(json: any): ProductLanguage {
    return ProductLanguageFromJSONTyped(json, false);
}

export function ProductLanguageFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductLanguage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'languageByLanguageId': !exists(json, 'languageByLanguageId') ? undefined : LanguageFromJSON(json['languageByLanguageId']),
        'languageId': !exists(json, 'languageId') ? undefined : json['languageId'],
        'productByProductId': !exists(json, 'productByProductId') ? undefined : ProductFromJSON(json['productByProductId']),
        'productId': !exists(json, 'productId') ? undefined : json['productId'],
    };
}

export function ProductLanguageToJSON(value?: ProductLanguage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'languageByLanguageId': LanguageToJSON(value.languageByLanguageId),
        'languageId': value.languageId,
        'productByProductId': ProductToJSON(value.productByProductId),
        'productId': value.productId,
    };
}

